import styled, { css } from 'styled-components'

import { Color, ColorShade, Typography, link, spacing, themeColor } from '@unbounded/unbounded-components'

export interface TextBlockStyleProps {
  type: 'error' | 'info' | 'loading'
  variant?: 'outline' | 'solid'
}

const getTextBlockColor = (type: string) => (type === 'error' ? themeColor(Color.danger) : themeColor(Color.primary))
const getForegroundColor = (type: string) =>
  type === 'error' ? themeColor(Color.danger, ColorShade.foreground) : themeColor(Color.primary, ColorShade.foreground)

export const Container = styled.div<TextBlockStyleProps>`
  display: flex;
  min-width: 0;
  padding: ${spacing(1)};

  ${props =>
    props.variant === 'outline'
      ? css<TextBlockStyleProps>`
          border: 1px solid ${cssProps => getTextBlockColor(cssProps.type)};
        `
      : css<TextBlockStyleProps>`
          background: ${cssProps => getTextBlockColor(cssProps.type)};
          color: ${cssProps => getForegroundColor(cssProps.type)};
          a,
          a:link {
            &:visited,
            &:hover {
              color: inherit;
              text-decoration: underline;
            }
          }
        `}

  margin-bottom: ${spacing(1)};
`

export const Icon = styled.div<TextBlockStyleProps>`
  flex-shrink: 1;
  min-width: 24px;
  color: ${props => (props.variant === 'outline' ? getTextBlockColor(props.type) : 'inherit')};
`

export const Content = styled.div`
  flex-grow: 1;
  margin-left: ${spacing(1)};
  word-break: break-word;

  a {
    ${link};
  }

  strong {
    ${Typography.textStrong};
  }
`
